import axios from "@/plugins/axios";

export default {
  getDocument(id) {
    return axios.get(`/finance_documents/${id}`);
  },
  getDocumentList(booking_id) {
    return axios.get(`/reports/${booking_id}/documents`);
  },

  addDocument(booking_id, { name, key }) {
    return axios.post(`/reports/${booking_id}/documents`, { name, key });
  },
  updateDocument(id, { display_name, old_name, dependent_id }) {
    // Note: CANNOT replace actual document
    // Other specifics (eg. Name) only
    return axios.post(`/finance_documents/${id}`, {
      display_name,
      old_name,
      booking_id: dependent_id,
    });
  },
  deleteDocument(id) {
    return axios.delete(`/finance_documents/${id}`);
  },
  deleteDocumentList(idList) {
    return axios.delete("/finance_documents", {
      data: { document_list: idList },
    });
  },
};
